export default function useIdentShopUrl() {
  const { identShop, mode } = useRuntimeConfig().public
  const languageStore = useLanguageStore()
  const { platform } = storeToRefs(useSystemStore())
  const { settings } = storeToRefs(useBusinessStore())
  const { isDirectSign, invitingBusinessId } = storeToRefs(useDirectSignStore())

  const publicInfoBusinessId = computed(() => (isDirectSign.value ? invitingBusinessId.value : ''))

  const { data: publicBusinessInfo } = usePublicInformation(publicInfoBusinessId, {
    watch: [publicInfoBusinessId],
  })

  const baseUrl =
    identShop.baseUrl || (mode === 'production' ? 'https://ident.skribble.com' : 'https://ident.scribital.com')

  return computed(() => {
    const businessUrl = publicBusinessInfo.value?.identShop?.url || settings.value.identShop?.url
    if (businessUrl) return businessUrl

    const url = `${baseUrl}/${languageStore.language}`
    return platform.value === 'EU' ? `${url}?currency=EUR` : url
  })
}
